import mixpanel from 'mixpanel-browser';
import { NavLink } from 'react-router-dom';

type Props = {
  isExternal: boolean;
  name: string;
  href: string;
  Icon: React.ElementType;
};

const SidebarItem = ({ isExternal, name, href, Icon }: Props) => {
  const handleNavLinkClick = () => {
    if (name !== 'How to install?') {
      mixpanel.track('Category Selected', { category: name });
    }
    if (name === 'Academy') {
      mixpanel.track('Academy Homeview', { category: name });
    }
  };

  if (isExternal) {
    return (
      <a
        href={href}
        className='group flex items-center px-2 py-2 rounded-md hover:bg-white text-xs'
        style={{ outline: 'none' }}
      >
        <Icon className='mr-2 flex-shrink-0 w-[24px] h-[24px]' aria-hidden='true' />
        {name}
      </a>
    );
  }
  return (
    <NavLink
      to={href}
      className={({ isActive }) =>
        `nav-link group flex items-center px-2 py-2 rounded-md hover:bg-white text-xs ${isActive ? 'bg-white' : ''}`
      }
      onClick={handleNavLinkClick}
      style={{ outline: 'none' }}
    >
      <Icon className='mr-2 flex-shrink-0 w-[24px] h-[24px]' aria-hidden='true' />
      {name}
    </NavLink>
  );
};

export { SidebarItem };
